export default "__VITE_ASSET__2ZHWnNDJ__"